import React from 'react';
import PopupHeader from '../../popupHeader';
import { useSelector, useDispatch } from 'react-redux';
import Modal from '../../../shared/modal/content';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import { saveOrgUnitGeneralInfoForm } from 'actions/organisation.js';

export default function OrgUnitGeneralInfoModal(props) {
  const updatedOrgUnitGeneralInfoForm = useSelector(
    (state) => state.organisationsReducer.updatedOrgUnitGeneralInfoForm
  );
  const messageData = useSelector((state) => state.globalMessageReducer.messageData);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin);
  const shortUrls = useSelector((state) => state.organisationsReducer.shortUrls);

  const dispatch = useDispatch();

  const saveButtonOnSave = (cb) => {
    dispatch(saveOrgUnitGeneralInfoForm(props.selectedOrgUnit.networkId, updatedOrgUnitGeneralInfoForm, cb));
  };

  return (
    <Modal show={true} hideWhenClickAway={false} className="shared-waiting-area-settings">
      <PopupHeader
        title={APP.LANGUAGE.OrgUnitGeneralInfo.Title}
        subtitle={props.selectedOrgUnit.name}
        helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpOrgUnitGeneralInfo}
      />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  updateOrView={props.updateOrView}
                  isAdmin={isAdmin}
                  messageData={messageData}
                  saveButtonOnSave={saveButtonOnSave}
                  selectedOrgUnit={props.selectedOrgUnit}
                />
              </div>
            </div>
            <CenterPanel
              updatedOrgUnitGeneralInfoForm={updatedOrgUnitGeneralInfoForm}
              updateOrView={props.updateOrView}
              isOnMobileOrTablet={props.isOnMobileOrTablet}
              isAdmin={isAdmin}
              shortUrls={shortUrls}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel
                updateOrView={props.updateOrView}
                isAdmin={isAdmin}
                messageData={messageData}
                saveButtonOnSave={saveButtonOnSave}
                selectedOrgUnit={props.selectedOrgUnit}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
